import React from 'react';

export const Cube3d = () => (
    <>
        <path d='M4 8v-2a2 2 0 0 1 2 -2h2'></path>
        <path d='M4 16v2a2 2 0 0 0 2 2h2'></path>
        <path d='M16 4h2a2 2 0 0 1 2 2v2'></path>
        <path d='M16 20h2a2 2 0 0 0 2 -2v-2'></path>
        <path d='M12 12.5l4 -2.5'></path>
        <path d='M8 10l4 2.5v4.5l4 -2.5v-4.5l-4 -2.5z'></path>
        <path d='M8 10v4.5l4 2.5'></path>
    </>
);